import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { demoLogin } from "../api/auth";
import { useAuth } from "../hooks/useAuth";

const FEATURES = [
  { icon: "💬", title: "AI Chat", desc: "Ask questions about sportsbook data in plain English" },
  { icon: "📊", title: "Dashboards", desc: "Pre-built KPI tiles with live synthetic data" },
  { icon: "🔔", title: "Service Status", desc: "Platform health monitoring and incident tracking" },
  { icon: "📈", title: "Reports", desc: "Scheduled analytics delivered to your inbox" },
];

export default function DemoLandingPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function handleDemo() {
    setLoading(true);
    setError("");
    try {
      const res = await demoLogin();
      login(res.data.access_token);
      navigate("/", { replace: true });
    } catch {
      setError("Demo is temporarily unavailable. Please try again shortly.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1D345F] to-[#2d4f8a] flex flex-col items-center justify-center px-4 py-16">
      {/* Logo / wordmark */}
      <div className="mb-10 text-center">
        <h1 className="text-4xl font-bold text-white tracking-tight">Betable AI</h1>
        <p className="mt-2 text-lg text-blue-200">Your sportsbook copilot</p>
      </div>

      {/* Feature grid */}
      <div className="mb-10 grid grid-cols-1 gap-4 sm:grid-cols-2 w-full max-w-xl">
        {FEATURES.map((f) => (
          <div key={f.title} className="rounded-xl bg-white/10 px-5 py-4 backdrop-blur-sm">
            <div className="text-2xl mb-1">{f.icon}</div>
            <p className="text-sm font-semibold text-white">{f.title}</p>
            <p className="text-xs text-blue-200 mt-0.5">{f.desc}</p>
          </div>
        ))}
      </div>

      {/* CTA */}
      <button
        onClick={handleDemo}
        disabled={loading}
        className="rounded-xl bg-white px-8 py-3.5 text-base font-semibold text-[#1D345F] shadow-lg hover:bg-blue-50 disabled:opacity-60 transition-colors"
      >
        {loading ? "Launching demo…" : "Try the demo →"}
      </button>

      {error && <p className="mt-4 text-sm text-red-300">{error}</p>}

      <p className="mt-6 text-xs text-blue-300 text-center max-w-sm">
        No sign-up required. All data is fully synthetic and does not represent real activity.
        Demo sessions expire after 60 minutes.
      </p>
    </div>
  );
}
